export const iconFontAwesomeBuildingsStore = (
	<i className="fa-solid fa-store"></i>
);
